import cx from 'classnames'
import { FC } from 'react'
import { separatorAnimation, textAnimation } from 'src/hooks/useAppear'
import { colors } from 'src/theme'
import { Separator } from 'src/theme/styled'

import { HeroProps } from '../types'

import * as SC from './styled'

const HeroText: FC<HeroProps> = ({
  className,
  htmlTag = 'hgroup',
  htmlTitleTag = 'h1',
  title,
  richTextProps,
  actionButtonProps,
  color = colors.blueLight,
}) => {
  const { animations } = useHeroTextMotion()
  return (
    <SC.Container
      className={cx('HeroText', className)}
      as={htmlTag}
      $color={color}
    >
      {title && (
        <>
          <SC.Title as={htmlTitleTag}>
            <SC.TextContent {...animations.title}>{title}</SC.TextContent>
          </SC.Title>
          <Separator aria-hidden role="separator" {...animations.separator} />
        </>
      )}
      <SC.Content>
        {richTextProps && (
          <SC.TextContent {...animations.text}>
            <SC._RichText {...richTextProps} />
          </SC.TextContent>
        )}

        {actionButtonProps && (
          <SC.ActionContent {...animations.action}>
            <SC._ActionButton {...actionButtonProps} />
          </SC.ActionContent>
        )}
      </SC.Content>
    </SC.Container>
  )
}

const useHeroTextMotion = () => ({
  animations: {
    separator: separatorAnimation({ delay: 0.5, duration: 1 }),
    title: textAnimation({
      delay: 0.8,
      y: 'var(--hero_text_title-offset)',
    }),
    text: textAnimation({ delay: 1, y: 'var(--hero_text_text-offset)' }),
    action: textAnimation({ delay: 1.15 }),
  },
})

export default HeroText
